import React, { useState } from 'react';
import { Spin } from 'antd';
import OnlineChannel from './onlineChannel';

const MarketPlaceScreen = () => {
  const [loading] = useState(false);

  return (
    <>
      <Spin spinning={loading}>
        <div className="main-heading">Market Place</div>
        <OnlineChannel />
      </Spin>
    </>
  );
};

export default MarketPlaceScreen;
